import moment from 'moment'
import React from 'react'
import { SingleDatePicker } from 'react-dates'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'

export default class ReportDate extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            calendarFocused: false
        }
    }

    onDateChange = (reportDate) => {
        if (reportDate) {
            this.props.updateReportDate(reportDate)
        }
    }
    onFocusChange = ({ focused }) => {
        this.setState(() => ({ calendarFocused: focused}))
    }
    isOutsideRange = (day) => {
        return day.isAfter(moment())
    }

    render() {
        return (
            <div className="reportdate">
                <div className="reportdate__title">
                    <h4>Production Day:</h4>
                </div>
                <SingleDatePicker
                            date={this.props.reportDate}
                            onDateChange={this.onDateChange}
                            focused={this.state.calendarFocused}
                            onFocusChange={this.onFocusChange}
                            numberOfMonths={1}
                            isOutsideRange={this.isOutsideRange}
                            showDefaultInputIcon inputIconPosition="after"
                            small
                />
            </div>
        )
    }
}